import VeteransDraft from "../schemas/VeteranDraft";
import { team } from "./stringConstants";

export const allVeteransDrafts: VeteransDraft[] = [
  {
    season: "2016/17",
    picks: [
      { team: team.detJews, player: "Carmelo Anthony", amongWorstPicks: true },
      { team: team.philoozers, player: "Pau Gasol" },
      { team: team.bknNets, player: "Dwight Howard", amongBestPicks: true },
      { team: team.uthFlames, player: "Trevor Ariza", amongWorstPicks: true },
      { team: team.bMovieBlazers, player: "Rudy Gay", amongBestPicks: true },
      { team: team.crashlots, player: "Dirk Nowitki" },
      { team: team.domHawks, player: "Dwyane Wade" },
      { team: team.phxBastards, player: "Rajon Rondo", amongWorstPicks: true },
      { team: team.chi88, player: "JJ Redick", amongBestPicks: true },
      { team: team.orlDunk, player: "Luol Deng", amongWorstPicks: true },
      { team: team.gswRandolph, player: "Deron Williams", amongWorstPicks: true },
    ],
  },
  {
    season: "2017/18",
    picks: [
      { team: team.gswRandolph, player: "Mike Conley", amongWorstPicks: true },
      { team: team.orlDunk, player: "LaMarcus Aldridge", amongBestPicks: true },
      { team: team.detJews, player: "Dwight Howard" },
      { team: team.crashlots, player: "Carmelo Anthony", amongWorstPicks: true },
      { team: team.phxBastards, player: "Al Horford", amongBestPicks: true },
      { team: team.bknNets, player: "Lou Williams", amongBestPicks: true },
      { team: team.chi88, player: "Trevor Ariza" },
      { team: team.bMovieBlazers, player: "Marcin Gortat", amongWorstPicks: true },
      { team: team.uthFlames, player: "JJ Redick", amongBestPicks: true },
      { team: team.domHawks, player: "Pau Gasol" },
      { team: team.philoozers, player: "Dwyane Wade", amongWorstPicks: true },
    ],
  },
  {
    season: "2018/19",
    picks: [
      { team: team.bknNets, player: "Chris Paul" },
      { team: team.philoozers, player: "DeAndre Jordan" },
      { team: team.crashlots, player: "Kyle Lowry" },
      { team: team.chi88, player: "Mike Conley", amongBestPicks: true },
      { team: team.detJews, player: "Dwight Howard", amongWorstPicks: true },
      { team: team.orlDunk, player: "Marc Gasol" },
      { team: team.bMovieBlazers, player: "Goran Dragic", amongWorstPicks: true },
      { team: team.phxBastards, player: "Brook Lopez" },
      { team: team.uthFlames, player: "Danilo Gallinari", amongBestPicks: true },
      { team: team.gswRandolph, player: "Al Horford", amongBestPicks: true },
      { team: team.domHawks, player: "Paul Millsap", amongBestPicks: true },
    ],
  },
  {
    season: "2019/20",
    picks: [
      { team: team.philoozers, player: "LaMarcus Aldridge" },
      { team: team.gswRandolph, player: "Mike Conley", amongWorstPicks: true },
      { team: team.phxBastards, player: "Danilo Gallinari", amongWorstPicks: true },
      { team: team.domHawks, player: "DeMar DeRozan", amongBestPicks: true },
      { team: team.crashlots, player: "Chris Paul", amongBestPicks: true },
      { team: team.bMovieBlazers, player: "Kyle Lowry", amongBestPicks: true },
      { team: team.chi88, player: "Al Horford" },
      { team: team.orlDunk, player: "Marc Gasol" },
      { team: team.uthFlames, player: "Brook Lopez" },
      { team: team.detJews, player: "DeAndre Jordan" },
      { team: team.bknNets, player: "Lou Williams" },
    ],
  },
  {
    season: "2020/21",
    picks: [
      { team: team.domHawks, player: "Russell Westbrook" },
      { team: team.philoozers, player: "Chris Paul", amongBestPicks: true },
      { team: team.detJews, player: "Blake Griffin", amongWorstPicks: true },
      { team: team.orlDunk, player: "Kyle Lowry" },
      { team: team.uthFlames, player: "LaMarcus Aldridge", amongWorstPicks: true },
      { team: team.bknNets, player: "DeMar DeRozan" },
      { team: team.phxBastards, player: "Jrue Holiday" },
      { team: team.chi88, player: "Brook Lopez", amongWorstPicks: true },
      { team: team.bMovieBlazers, player: "John Wall", amongWorstPicks: true },
      { team: team.crashlots, player: "Lou Williams", amongWorstPicks: true },
      { team: team.gswRandolph, player: "Gordon Hayward" },
    ],
  },
  {
    season: "2021/22",
    picks: [
      { team: team.bknNets, player: "LeBron James" },
      { team: team.philoozers, player: "Tobias Harris" },
      { team: team.bMovieBlazers, player: "Chris Paul", amongBestPicks: true },
      { team: team.orlDunk, player: "Russell Westbrook" },
      { team: team.chi88, player: "Jrue Holiday", amongBestPicks: true },
      { team: team.crashlots, player: "DeMar DeRozan", amongBestPicks: true },
      { team: team.domHawks, player: "Kyle Lowry" },
      { team: team.phxBastards, player: "Kemba Walker", amongWorstPicks: true },
      { team: team.uthFlames, player: "Gordon Hayward" },
      { team: team.gswRandolph, player: "Mike Conley" },
      { team: team.detJews, player: "Brook Lopez" },
    ],
  },
  {
    season: "2022/23",
    picks: [
      { team: team.uthFlames, player: "LeBron James" },
      { team: team.domHawks, player: "Paul George" },
      { team: team.detJews, player: "Kawhi Leonard" },
      { team: team.phxBastards, player: "Jrue Holiday" },
      { team: team.gswRandolph, player: "DeMar DeRozan", amongBestPicks: true },
      { team: team.bknNets, player: "Nikola Vucevic", amongBestPicks: true },
      { team: team.crashlots, player: "Chris Paul" },
      { team: team.chi88, player: "Jonas Valanciunas" },
      { team: team.bMovieBlazers, player: "Khris Middleton", amongWorstPicks: true },
      { team: team.orlDunk, player: "Tobias Harris" },
      { team: team.philoozers, player: "Klay Thompson", amongBestPicks: true },
    ],
  },
  {
    season: "2023/24",
    picks: [
      { team: team.orlDunk, player: "Nikola Vucevic" },
      { team: team.gswRandolph, player: "Kyrie Irving" },
      { team: team.domHawks, player: "James Harden", amongBestPicks: true },
      { team: team.detJews, player: "DeMar DeRozan", amongBestPicks: true },
      { team: team.crashlots, player: "LeBron James", amongBestPicks: true },
      { team: team.chi88, player: "Bradley Beal", amongWorstPicks: true },
      { team: team.bknNets, player: "Rudy Gobert", amongBestPicks: true },
      { team: team.phxBastards, player: "Jrue Holiday" },
      { team: team.bMovieBlazers, player: "Brook Lopez" },
      { team: team.uthFlames, player: "Klay Thompson", amongWorstPicks: true },
      { team: team.philoozers, player: "CJ McCollum", amongBestPicks: true },
    ],
  },
  {
    season: "2024/25",
    picks: [
      { team: team.crashlots, player: "James Harden", amongBestPicks: true },
      { team: team.bknNets, player: "Kevin Durant", amongBestPicks: true },
      { team: team.phxBastards, player: "Rudy Gobert" },
      { team: team.domHawks, player: "Damian Lillard", amongBestPicks: true },
      { team: team.detJews, player: "Jimmy Butler" },
      { team: team.philoozers, player: "LeBron James", amongBestPicks: true },
      { team: team.bMovieBlazers, player: "Nikola Vucevic", amongBestPicks: true },
      { team: team.orlDunk, player: "DeMar DeRozan" },
      { team: team.chi88, player: "Jrue Holiday", amongWorstPicks: true },
      { team: team.gswRandolph, player: "CJ McCollum" },
      { team: team.uthFlames, player: "Kawhi Leonard" },
    ],
  },
];
